import { Button } from '../Button';
import React from 'react';
export default function ExportButton({ downloadUrl, ...props }) {
    return (React.createElement(Button, { ...props, 
        // variant={props.variant || 'outlined'}
        // color={props.color || 'primary'}
        onClick: event => {
            const href = document.createElement('a');
            href.setAttribute('href', downloadUrl);
            href.setAttribute('download', 'download');
            href.click();
            href.remove();
            props.onClick && props.onClick(event);
        } }));
}
